<div
  class="card-body d-flex justify-content-center text-center flex-column p-8"
>
  <a class="text-gray-800 text-hover-primary d-flex flex-column cursor-pointer">
    <div class="symbol symbol-75px mb-6"><img [src]="icon" alt="" /></div>
    <div class="fs-5 fw-bolder mb-2">{{ title }}</div>
  </a>
  <div class="fs-7 fw-bold text-gray-400 mt-auto">{{ description }}</div>
</div>
